import { useCallback, useState } from "react";

import PageLoading from "components/loading/PageLoading";
import FullScreenModal from "ds/components/FullScreenModal";
import { showSimpleLeaveConfirmation } from "ds/components/LeaveConfirmationModal/Simple";
import useErrorHandle from "hooks/useErrorHandle";
import useTitle from "hooks/useTitle";

import { BUILT_IN_GITHUB_INTEGRATION_NAME } from "../../constants";
import useCloseFullScreenModal from "../../useCloseFullScreenModal";
import VCSIntegrationsManageGitHubManual from "../Manual";
import useGetGitHubIntegration from "./useGetGitHubIntegration";

const VCSIntegrationsManageGitHubEdit = () => {
  const [isDirty, setIsDirty] = useState(false);

  const { integration, isPageLoading, error } = useGetGitHubIntegration();
  const { handleOnClose } = useCloseFullScreenModal();

  const modalCloseClickHandler = useCallback(async () => {
    if (isDirty) {
      await showSimpleLeaveConfirmation();
    }

    handleOnClose();
  }, [handleOnClose, isDirty]);

  const toggleIsDirty = useCallback((value: boolean) => {
    setIsDirty(value);
  }, []);

  useTitle(`Edit integration · ${BUILT_IN_GITHUB_INTEGRATION_NAME}`);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <FullScreenModal title="Edit GitHub integration" onClose={modalCloseClickHandler}>
      {isPageLoading && <PageLoading />}
      {!isPageLoading && (
        <VCSIntegrationsManageGitHubManual
          integration={integration}
          onIsDirtyChange={toggleIsDirty}
        />
      )}
    </FullScreenModal>
  );
};

export default VCSIntegrationsManageGitHubEdit;
